import { useMemo, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { products } from "../data/products";
import { ProductCard } from "../components/ProductCard";
import { Reveal } from "../components/Reveal";

const CATEGORIES = ["All", ...new Set(products.map((p) => p.category))];

export default function Catalogue() {
  const [active, setActive] = useState("All");
  const visible = useMemo(
    () => (active === "All" ? products : products.filter((p) => p.category === active)),
    [active]
  );

  return (
    <main className="pt-32 md:pt-40" data-testid="catalogue-page">
      <header className="mx-auto max-w-7xl px-6 pb-16 text-center md:px-10 md:pb-20">
        <Reveal>
          <p className="mb-5 text-xs uppercase tracking-[0.35em] text-golddark">The catalogue</p>
        </Reveal>
        <Reveal delay={0.1}>
          <h1 className="font-serif text-5xl tracking-tighter text-ink md:text-7xl" data-testid="catalogue-heading">
            The <em className="italic text-golddark">Collection</em>
          </h1>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="mx-auto mt-6 max-w-md text-base leading-relaxed text-smoke">
            Eight pieces, one garden. Sterling silver and gold-finished jewellery,
            each carrying a leaf, a wreath, or a violet stone.
          </p>
        </Reveal>
      </header>

      <Reveal delay={0.1} className="mx-auto max-w-7xl px-6 md:px-10">
        <div className="mb-14 flex flex-wrap justify-center gap-3" data-testid="catalogue-filters">
          {CATEGORIES.map((cat) => (
            <button
              key={cat}
              onClick={() => setActive(cat)}
              data-testid={`filter-btn-${cat.toLowerCase()}`}
              className={`rounded-full border px-5 py-2 text-[11px] uppercase tracking-[0.2em] transition-all duration-400 ${
                active === cat
                  ? "border-ink bg-ink text-ivory"
                  : "border-borderline bg-transparent text-smoke hover:border-gold hover:text-golddark"
              }`}
            >
              {cat}
            </button>
          ))}
        </div>
      </Reveal>

      <section className="mx-auto max-w-7xl px-6 pb-32 md:px-10">
        <motion.div layout className="grid grid-cols-1 gap-x-5 gap-y-14 sm:grid-cols-2 lg:grid-cols-4" data-testid="catalogue-grid">
          <AnimatePresence mode="popLayout">
            {visible.map((p, i) => (
              <ProductCard key={p.handle} product={p} index={i} />
            ))}
          </AnimatePresence>
        </motion.div>
        <p className="mt-16 text-center text-[11px] uppercase tracking-[0.3em] text-smoke" data-testid="catalogue-count">
          {visible.length} of {products.length} pieces
        </p>
      </section>
    </main>
  );
}
